/**
 * Canonical employee bank-name list.
 *
 * Single source of truth for every bank-name dropdown in the app — the part-timer register form
 * and the View / Edit forms for part-timer, contractor and full-time employees. Keep this list in
 * sync with the OCBC GIRO payroll mapping in the backend
 * (JAVA-NEXUS-BACKEND/docs/bank-code-mapping.md and getGiroBankCode / getBankCodeFromName).
 */
export const BANK_LIST: string[] = [
    'ANEXT BANK PTE LTD',
    'AUST AND NEW ZEALAND BANKING GROUP LTD',
    'BANCO SANTANDER, S.A.',
    'BANGKOK BANK PUBLIC COMPANY LTD',
    'BANK OF AMERICA NA',
    'BANK OF CHINA LIMITED',
    'BANK OF EAST ASIA LIMITED',
    'BANK OF INDIA',
    'BANK OF TAIWAN',
    'BANK OF TOKYO-MITSUBISHI UFJ LIMITED',
    'BANK SARASIN AND CIE AG',
    'BANQUE INTERNATIONALE A LUXEMBOURG',
    'BARCLAYS BANK PLC',
    'BNP PARIBAS',
    'BNP PARIBAS SECURITIES SERVICES',
    'CATHAY UNITED BANK',
    'CENTRAL DEPOSITORY (PTE) LTD',
    'CHINATRUST COMMERCIAL BANK CO LTD',
    'CIMB BANK BHD',
    'CITIBANK NA',
    'CITIBANK SINGAPORE LIMITED',
    'CLS BANK INTERNATIONAL',
    'COMMERZBANK AKTIENGESELLSCHAFT',
    'CREDIT AGRICOLE CIB, SINGAPORE',
    'CREDIT SUISSE AG',
    'DBS BANK LTD',
    'DEUTSCHE BANK AG',
    'DNB BANK ASA',
    'FAR EASTERN BANK LTD',
    'FIRST ABU DHABI BANK P.J.S.C.',
    'FIRST COMMERCIAL BANK',
    'GPAY NETWORK (S) PTE LTD',
    'GREEN LINK DIGITAL BANK PTE LTD',
    'GXS BANK PTE LTD',
    'HABIB BANK LTD',
    'HL BANK',
    'HONG LEONG FINANCE LIMITED',
    'HSBC (CORPORATE)',
    'HSBC (PERSONAL)',
    'HSBC PRIVATE BANK (SUISSE) SA',
    'HUA NAN COMMERCIAL BANK LTD',
    'INDIAN BANK',
    'INDIAN OVERSEAS BANK',
    'INDUSTRIAL & COMMERCIAL BANK OF CHINA',
    'ING BANK NV',
    'INTESA SANPAOLO SPA',
    'JPMORGAN CHASE BANK NA',
    'KBC BANK',
    'KOREA EXCHANGE BANK',
    'LANDESBANK BADEN-WURTTEMBERG',
    'LIQUID GROUP PTE LTD',
    'MACQUARIE BANK LIMITED',
    'MALAYAN BANKING BHD',
    'MARIBANK SINGAPORE PRIVATE LIMITED',
    'MATCHMOVE PAY PTE LTD',
    'MAYBANK SINGAPORE LIMITED',
    'MEGA INTERNATIONAL COMMERCIAL BK CO',
    'MIZUHO CORPORATE BANK LTD',
    'MONETARY AUTHORITY OF SINGAPORE',
    'MUFG BANK, LTD',
    'NATIONAL AUSTRALIA BANK LTD',
    'NATIONAL BANK OF KUWAIT SAK',
    'NATIXIS',
    'NORDEA BANK FINLAND PLC',
    'OVERSEA-CHINESE BKG CORP LTD',
    'POSB BANK',
    'PT BANK NEGARA INDONESIA (PERSERO)',
    'QATAR NATIONAL BANK SAQ',
    'RABOBANK NEDERLAND',
    'RAZER MERCHANT SERVICES (SG) PTE LTD',
    'RHB BANK BHD',
    'ROYAL BANK OF CANADA',
    'SGX DERIVATIVES CLEARING LIMITED',
    'SHANGHAI PUDONG DEVELOPMENT BANK CO., LTD.',
    'SHINHAN BANK',
    'SING INVESTMENTS & FINANCE LTD',
    'SINGAPORE ISLAND BANK LIMITED',
    'SINGAPURA FINANCE LTD',
    'SINGCASH PTE LTD',
    'SKANDINAVISKA ENSKILDA BANKEN AB',
    'STANDARD CHARTERED BANK (S) LTD',
    'STATE BANK OF INDIA',
    'SUMITOMO MITSUI BANKING CORP',
    'THE ROYAL BANK OF SCOTLAND, PLC',
    'TRANSFERWISE SINGAPORE PTE LTD',
    'TRUST BANK SINGAPORE LIMITED',
    'UBS AG',
    'UCO BANK',
    'UNICREDIT BANK AG',
    'UNITED OVERSEAS BANK LIMITED',
];
